import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      variant: 'info',
      text: '',
    },
  },
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'cil-columns',
    // children: [
    //   {
    //     name: 'Present',
    //     url: '/calendar',
    //   },
    //   {
    //     name: 'History',
    //     url: '/calendarHistory',
    //   },
    // ],
  },
  {
    name: 'Bookings',
    url: '/booking',
    icon: 'cil-tags',
    children: [
      {
        name: 'Normal',
        url: '/booking',
      },
      {
        name: 'Recurrant',
        url: '/bookingReoccur',
      },
      {
        name: 'Category',
        url: '/bookingCategory',
      },
    ],
  },
  {
    name: 'Customers',
    url: '/customer',
    icon: 'cil-user',
  },
  {
    name: 'Academy',
    url: '/coach',
    icon: 'cil-education',
    children: [
      {
        name: 'Classes',
        url: '/class',
      },
      {
        name: 'Recurrant Classes',
        url: '/bookingReoccur',
      },
      {
        name: 'Coaches',
        url: '/coach',
      },
    ],
  },
  {
    name: 'Memberships',
    url: '/membership',
    icon: 'cil-credit-card',
  },
  {
    name: 'Offers',
    url: '/offer',
    icon: 'cil-calendar',
  },
  {
    name: 'Disabled',
    url: '/disabled',
    icon: 'cil-x',
  },
  {
    name: 'Courts',
    url: '/court',
    icon: 'cil-tennis-ball',
  },
  {
    name: 'Addon',
    url: '/facilityAddon',
    icon: 'cil-layers',
  },
  {
    name: 'Images',
    url: '/facilityImages',
    icon: 'cil-image',
  },
  {
    name: 'Schedule',
    url: '/facilitySchedule',
    icon: 'cil-av-timer',
    children: [
      {
        name: 'Schedule Display',
        url: '/facilitySchedule',
      },
      {
        name: 'Timing',
        url: '/facilityTiming',
      },
    ],
  },
  {
    name: 'Promo Codes',
    url: '/promotion',
    icon: 'cil-tags',
    children: [
      {
        name: 'Codes',
        url: '/promotion',
      },
      {
        name: 'Configuration',
        url: '/promotionConfiguration',
      },
    ],
  },
  {
    name: 'Users',
    url: '/userFacility',
    icon: 'cil-group',
  },
  // {
  //   name: 'Owners',
  //   url: '/owner',
  //   icon: 'cil-group',
  // },
  // {
  //   name: 'Reports',
  //   url: '/payment',
  //   icon: 'cil-money',
  // },
  //       {
  //       name: 'New Reports',
  //       url: '/report',
  //       badge: {
  //         variant: 'info',
  //         text: 'NEW',
  //       },
  //     },

  {
    name: 'Reports',
    icon: 'cil-money',
    children: [
      {
        name: 'Reports',
        url: '/payment',
      },
      {
        name: 'New Reports',
        url: '/report',
        badge: {
          variant: 'info',
          text: 'NEW',
        },
      },
    ],
  },
  {
    name: 'Tournaments',
    icon: 'cil-money',
    children: [
      {
        name: 'Active',
        url: '/tournaments',
      },
      {
        name: 'History',
        url: '/tournamentsHistory',

      },
    ],
  },
];
export const navStaffItems: INavData[] = [
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'cil-columns',
    // children: [
    //   {
    //     name: 'Present',
    //     url: '/calendar',
    //   },
    //   {
    //     name: 'History',
    //     url: '/calendarHistory',
    //   },
    // ],
  },
  {
    name: 'Bookings',
    url: '/booking',
    icon: 'cil-tags',
    children: [
      {
        name: 'Normal',
        url: '/booking',
      },
      {
        name: 'Recurrant',
        url: '/bookingReoccur',
      },
      {
        name: 'Category',
        url: '/bookingCategory',
      },
    ],
  },
  {
    name: 'Academy',
    url: '/coach',
    icon: 'cil-education',
    children: [
      {
        name: 'Classes',
        url: '/class',
      },
      {
        name: 'Recurrant Classes',
        url: '/bookingReoccur',
      },
      {
        name: 'Coaches',
        url: '/coach',
      },
    ],
  },
  {
    name: 'Customers',
    url: '/customer',
    icon: 'cil-user',
  },
  {
    name: 'Memberships',
    url: '/membership',
    icon: 'cil-credit-card',
  },
];
export const navCoachItems: INavData[] = [
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'cil-columns',
    // children: [
    //   {
    //     name: 'Present',
    //     url: '/calendar',
    //   },
    //   {
    //     name: 'History',
    //     url: '/calendarHistory',
    //   },
    // ],
  },
  {
    name: 'Bookings',
    url: '/booking',
    icon: 'cil-tags',
    children: [
      {
        name: 'Normal',
        url: '/booking',
      },
    ],
  },
  {
    name: 'Academy',
    url: '/coach',
    icon: 'cil-education',
    children: [
      {
        name: 'Classes',
        url: '/class',
      },
      {
        name: 'Recurrant Classes',
        url: '/bookingReoccur',
      },
      {
        name: 'Coaches',
        url: '/coach',
      },
    ],
  },
];
export const navAdminItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      variant: 'info',
      text: '',
    },
  },
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'cil-columns',
    // children: [
    //   {
    //     name: 'Present',
    //     url: '/calendar',
    //   },
    //   {
    //     name: 'History',
    //     url: '/calendarHistory',
    //   },
    // ],
  },
  {
    name: 'Bookings',
    url: '/booking',
    icon: 'cil-tags',
    children: [
      {
        name: 'Normal',
        url: '/booking',
      },
      {
        name: 'Recurrant',
        url: '/bookingReoccur',
      },
      {
        name: 'Category',
        url: '/bookingCategory',
      },
    ],
  },
  {
    name: 'Customers',
    url: '/customer',
    icon: 'cil-user',
  },
  {
    name: 'Academy',
    url: '/coach',
    icon: 'cil-education',
    children: [
      {
        name: 'Classes',
        url: '/class',
      },
      {
        name: 'Recurrant Classes',
        url: '/bookingReoccur',
      },
      {
        name: 'Coaches',
        url: '/coach',
      }
    ],
  },
  {
    name: 'Memberships',
    url: '/membership',
    icon: 'cil-credit-card',
  },
  {
    name: 'Offers',
    url: '/offer',
    icon: 'cil-calendar',
  },
  {
    name: 'Disabled',
    url: '/disabled',
    icon: 'cil-x',
  },
  {
    name: 'Courts',
    url: '/court',
    icon: 'cil-tennis-ball',
  },
  {
    name: 'Addon',
    url: '/facilityAddon',
    icon: 'cil-layers',
  },
  {
    name: 'Schedule',
    url: '/facilitySchedule',
    icon: 'cil-av-timer',
    children: [
      {
        name: 'Schedule Display',
        url: '/facilitySchedule',
      },
      {
        name: 'Timing',
        url: '/facilityTiming',
      },
    ],
  },
  {
    name: 'Event',
    url: '/facilityEvent',
    icon: 'cil-calendar-check',
  },
  {
    name: 'Images',
    url: '/facilityImages',
    icon: 'cil-image',
  },
  {
    name: 'Promo Codes',
    url: '/promotion',
    icon: 'cil-tags',
    children: [
      {
        name: 'Codes',
        url: '/promotion',
      },
      {
        name: 'Configuration',
        url: '/promotionConfiguration',
      },
    ],
  },
  {
    name: 'Users',
    url: '/userFacility',
    icon: 'cil-group',
  },
  // {
  //   name: 'Owners',
  //   url: '/owner',
  //   icon: 'cil-group',
  // },
  {
    name: 'Reports',
    icon: 'cil-money',
    children: [
      {
        name: 'Main Report',
        url: '/payment',
      },
      {
        name: 'Custom Reports',
        url: '/report',
        badge: {
          variant: 'info',
          text: 'NEW',
        },
      },
    ],
  },
  {
    name: 'Tournaments',
    icon: 'cil-money',
    children: [
      {
        name: 'Active',
        url: '/tournaments',
      },
      {
        name: 'History',
        url: '/tournamentsHistory',

      },
    ],
  },
  
  {
    name: 'Admin',
    title: true,
  },
  {
    name: 'Tutorials',
    url: '/tutorials',
    icon: 'cil-file',
  },
  {
    name: 'Facilities',
    url: '/facility',
    icon: 'cil-house',
    children: [
      {
        name: 'Change Facility',
        url: '/facilityList',
      },
      {
        name: 'Full list',
        url: '/facility',
      },
      {
        name: 'Payment Methods',
        url: '/facilityPaymentMethod',
      }
    ],
  },
  {
    name: 'Tap',
    url: '/tapFacilityFile',
    icon: 'cil-credit-card',
    children: [
      {
        name: 'Files',
        url: '/tapFacilityFile',
      },
      {
        name: 'Onboarding',
        url: '/tapFacilityOnboarding',
      }
    ],
  },
  {
    name: 'Invistgations',
    url: '/invistigation',
    icon: 'cil-search',
  },
  {
    name: 'Arena Promotions',
    url: '/promotionAdmin',
    icon: 'cil-tags',
    badge: {
      variant: 'info',
      text: '',
    },
  },
  {
    name: 'Users',
    url: '/user',
    icon: 'cil-group',
  },
  {
    name: 'Owners',
    url: '/owner',
    icon: 'cil-contact',
  },
];
export const navComponentItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'cil-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW',
    },
  },
  {
    name: 'Theme',
    url: '/theme',
    icon: 'cil-drop',
    children: [
      {
        name: 'Colors',
        url: '/theme/colors',
      },
      {
        name: 'Typography',
        url: '/theme/typography',
      },
    ],
  },
  {
    name: 'Components',
    title: true,
  },
  {
    name: 'Base',
    url: '/base',
    icon: 'cil-puzzle',
    children: [
      {
        name: 'Breadcrumbs',
        url: '/base/breadcrumbs',
      },
      {
        name: 'Cards',
        url: '/base/cards',
      },
      {
        name: 'Carousels',
        url: '/base/carousels',
      },
      {
        name: 'Collapses',
        url: '/base/collapses',
      },
      {
        name: 'Images',
        url: '/base/images',
      },
      {
        name: 'Jumbotrons',
        url: '/base/jumbotrons',
      },
      {
        name: 'List Groups',
        url: '/base/list-groups',
      },
      {
        name: 'Media',
        url: '/base/media-objects',
      },
      {
        name: 'Navbars',
        url: '/base/navbars',
      },
      {
        name: 'Navs',
        url: '/base/navs',
      },
      {
        name: 'Pagination',
        url: '/base/paginations',
      },
      {
        name: 'Popovers',
        url: '/base/popovers',
      },
      {
        name: 'Progress',
        url: '/base/progress',
      },
      {
        name: 'Switches',
        url: '/base/switches',
      },
      {
        name: 'Tabs',
        url: '/base/tabs',
      },
      {
        name: 'Tooltips',
        url: '/base/tooltips',
      },
    ],
  },
  {
    name: 'Buttons',
    url: '/buttons',
    icon: 'cil-cursor',
    children: [
      {
        name: 'Buttons',
        url: '/buttons/buttons',
      },
      {
        name: 'Button Groups',
        url: '/buttons/button-groups',
      },
      {
        name: 'Dropdowns',
        url: '/buttons/dropdowns',
      },
      {
        name: 'Brand Buttons',
        url: '/buttons/brand-buttons',
      },
    ],
  },
  {
    name: 'Charts',
    url: '/charts',
    icon: 'cil-chart-pie',
  },
  {
    name: 'Editors',
    url: '/editors',
    icon: 'cil-code',
    children: [
      {
        name: 'Text Editors',
        url: '/editors/text-editors',
      },
      {
        name: 'Code Editors',
        url: '/editors/code-editors',
      },
    ],
  },
  {
    name: 'Forms',
    url: '/forms',
    icon: 'cil-notes',
    children: [
      {
        name: 'Basic Forms',
        url: '/forms/basic-forms',
      },
      {
        name: 'Advanced',
        url: '/forms/advanced-forms',
      },
      {
        name: 'Validation',
        url: '/forms/validation-forms',
      },
    ],
  },
  {
    name: 'Google Maps',
    url: '/google-maps',
    icon: 'cil-map',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Icons',
    url: '/icons',
    icon: 'cil-brush-alt',
    children: [
      {
        name: 'CoreUI Icons',
        url: '/icons/coreui-icons',
        badge: {
          variant: 'success',
          text: 'Free',
        },
      },
      {
        name: 'Brands',
        url: '/icons/brands',
      },
      {
        name: 'Flags',
        url: '/icons/flags',
      },
    ],
  },
  {
    name: 'Notifications',
    url: '/notifications',
    icon: 'cil-bell',
    children: [
      {
        name: 'Alerts',
        url: '/notifications/alerts',
      },
      {
        name: 'Badges',
        url: '/notifications/badges',
      },
      {
        name: 'Modals',
        url: '/notifications/modals',
      },
      {
        name: 'Toasters',
        url: '/notifications/toasters',
      },
    ],
  },
  {
    name: 'Plugins',
    url: '/plugins',
    icon: 'cil-input-power',
    children: [
      {
        name: 'FullCalendar',
        url: '/plugins/fullcalendar',
        badge: { text: 'New', variant: 'info' }
      },
      {
        name: 'Draggable',
        url: '/plugins/draggable-cards',
      },
      {
        name: 'Spinners',
        url: '/plugins/spinners',
      },
    ],
  },
  {
    name: 'Tables',
    url: '/tables',
    icon: 'cil-columns',
    children: [
      {
        name: 'DataTable',
        url: '/tables/datatables',
      },
      {
        name: 'Standard Tables',
        url: '/tables/tables',
      },
    ],
  },
  {
    name: 'Widgets',
    url: '/widgets',
    icon: 'cil-calculator',
  },
  {
    name: 'Extras',
    title: true,
  },
  {
    name: 'Pages',
    url: '/pages',
    icon: 'cil-star',
    children: [
      {
        name: 'Login',
        url: '/login',
      },
      {
        name: 'Register',
        url: '/register',
      },
      {
        name: 'Error 404',
        url: '/404',
      },
      {
        name: 'Error 500',
        url: '/500',
      },
    ],
  },
  // {
  //   name: 'Disabled',
  //   url: '/dashboard',
  //   icon: 'cil-ban',
  //   badge: {
  //     variant: 'secondary',
  //     text: 'NEW'
  //   },
  //   attributes: { disabled: true },
  // },
  {
    name: 'Apps',
    url: '/apps',
    icon: 'cil-layers',
    children: [
      {
        name: 'Invoicing',
        url: '/apps/invoicing/invoice',
        icon: 'cil-description',
        badge: {
          variant: 'danger',
          text: 'PRO',
        },
      },
      {
        name: 'Email',
        url: '/apps/email',
        icon: 'cil-envelope-open',
      },
    ],
  },
];
